// src/components/AddGameForm.js
import { useState } from 'react';
import { supabase } from '../supabaseClient';
import { colors } from '../styles/colors';

const AddGameForm = ({ onGameAdded }) => {
  const [title, setTitle] = useState('');
  const [year, setYear] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('games')
        .insert([{ title, year }])
        .select()
        .single();
      if (error) throw error;
      onGameAdded(data);
      setTitle(''); setYear('');
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  return (
    <form style={formStyle} onSubmit={handleSubmit}>
      <h3 style={titleStyle}>Add New Game</h3>
      <input placeholder="Title" value={title} onChange={(e)=>setTitle(e.target.value)} required style={inputStyle}/>
      <input placeholder="Year" value={year} onChange={(e)=>setYear(e.target.value)} style={inputStyle}/>
      <button type="submit" disabled={loading} style={{...buttonStyle, opacity: loading ? 0.7 : 1}}>
        {loading ? 'Adding...' : 'Add Game'}
      </button>
    </form>
  );
};

const formStyle = {
  display: 'flex', flexDirection: 'column', gap: '0.75rem',
  backgroundColor: colors.background, padding: '1rem', borderRadius: '12px',
  boxShadow: '0 8px 18px rgba(0,0,0,0.08)',
};
const titleStyle = { color: colors.primary, margin: 0 };
const inputStyle = {
  padding: '0.5rem 0.75rem', borderRadius: '8px', border: '1px solid #ccc',
  outline: 'none', fontSize: '0.95rem'
};
const buttonStyle = {
  padding: '0.6rem 1rem', borderRadius: '8px', border: 'none',
  backgroundColor: colors.button, color: '#fff', fontWeight: 600
};

export default AddGameForm;